import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  IconButton
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const VacantTable = props => {
  const { className, vacants, history, ...rest } = props;

  const classes = useStyles();

  const [selectedVacants, setSelectedVacants] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handleSelectAll = event => {
    const { vacants } = props;

    let selectedVacants;

    if (event.target.checked) {
      selectedVacants = vacants.map(user => user.cognitoId);
    } else {
      selectedVacants = [];
    }

    setSelectedVacants(selectedVacants);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedVacants.indexOf(id);
    let newSelectedVacants = [];

    if (selectedIndex === -1) {
      newSelectedVacants = newSelectedVacants.concat(selectedVacants, id);
    } else if (selectedIndex === 0) {
      newSelectedVacants = newSelectedVacants.concat(selectedVacants.slice(1));
    } else if (selectedIndex === selectedVacants.length - 1) {
      newSelectedVacants = newSelectedVacants.concat(selectedVacants.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedVacants = newSelectedVacants.concat(
        selectedVacants.slice(0, selectedIndex),
        selectedVacants.slice(selectedIndex + 1)
      );
    }

    setSelectedVacants(newSelectedVacants);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content} style={{maxHeight: "60vh", overflow: 'auto'}}>

          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Empresa</TableCell>
                  <TableCell>Categoría</TableCell>
                  <TableCell>Ciudad</TableCell>
                  <TableCell>Contacto</TableCell>
                  <TableCell>Teléfono</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Fechas apertura</TableCell>
                  <TableCell>Beneficios económicos</TableCell>
                  <TableCell>Beneficios comida</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {vacants.slice(0, rowsPerPage).map(user => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={user.id}
                    selected={selectedVacants.indexOf(user.cognitoId) !== -1}
                  >
                    <TableCell>{user.companyName}</TableCell>
                    <TableCell>{user.category}</TableCell>
                    <TableCell>{user.city}</TableCell>
                    <TableCell>{user.contact}</TableCell>
                    <TableCell>{user.phone}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{user.dates}</TableCell>
                    <TableCell>{user.benefitEconomy}</TableCell>
                    <TableCell>{user.benefitMeal}</TableCell>
                    <TableCell>
                      <IconButton
                        color="inherit"
                        onClick={() => {}}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="inherit"
                        onClick={() => {}}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={vacants.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

VacantTable.propTypes = {
  className: PropTypes.string,
  vacants: PropTypes.array.isRequired
};

export default withRouter(VacantTable);
